import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Richtext } from 'dhx-richtext';
import { Router, ActivatedRoute  } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MailFieldsService } from '../../Master/mailfields/mailfields.service';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { DialogService } from 'ng2-bootstrap-modal';
import { UserService } from '../../Master/user/user.service';
import { MailgroupService } from '../../mailgroup/mailgroup.service';
import { HelpdeskComponent } from '../../Shared/helpdesk/helpdesk.component';
import { MailTemplateService } from '../../Template/mailtemplate/mailtemplate.service';
import { MailTemplate } from '../../Template/mailtemplate/mailtemplate';
import { MailConfig } from './mailconfig';
import { MailconfigService } from './mailconfig.service';
import { DatabaseService } from '../../Master/database/database.service';
import { FormconfigService } from '../formconfig/formconfig.service';
import { LocalService } from '../../local.service';
import {encryptdecrypt} from '../../encryptdecrypt';
declare var $: any;

@Component({
  selector: 'app-mailconfig',
  templateUrl: './mailconfig.component.html',
  styleUrls: ['./mailconfig.component.css'],
  providers: [MailFieldsService, ToastrService]
})
export class MailconfigComponent implements OnInit, AfterViewInit {
  sendMenuId: number;
  sendPageName: string = 'Mail Config';

  public richtext: any; userid: number;
  _mailGroupListtmp: any = []; _mailGroupList: any = []; public _metaFieldsList: any;
  _dropdownSettings: any; action: string;
  _toMailDropdownSettings: any; _userMailList: any = []; _selectedItems: any = [];
  _toMailList: any = []; _ccMailList: any = []; _mailTempList: any = []; _selectedMailTemplate: any = []; _selectedToIds: any = []; _selectedCcIds: any = [];
  _toTemplateDropdownSettings: any; _templateList: any = []; p: number = 1; itemsPerPage: number = 10; public searchText: string; confmsg: string; msg: string;
  _groupMapped: any = []; _toMailIdMapped: any[]; _ccMailIdMapped: any[]; formTocuhed: boolean;
  _mailConfigList: any = [];
  _mailConfigListactive: any = [];
  _mailConfigListTmp: any[]; currentMailConfig: string;
  _mailConfigid: any; _mailTemplateId: number; databases: any = []; selectedDb: boolean; public queryStrDb: any; hideDiv: boolean;
  _menuId: any
  //menu rights defining buttons
  _actionRights: any; submitShow: boolean;
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean;
  events: any[] = [];
  selectedevent: any = 0; selectevent: boolean = false; requestTypes: any[] = [];
  labeltext: string = null; formConfigList: any[] = [];
  showall: boolean = true;
  showallstatus: boolean = false;
  formconfigddl: boolean = false; requesttypeddl: boolean = false
  tempFormConfigList = [];
  scheduledtabshow: boolean = false; showtimepicker: boolean = false; showhourpicker: boolean = false;// showtimepicker: boolean = false;
  schedulespecifictime: any;
  scheduleinterval: any;
  scheduletypeedit: string = '';
  scheduledaysedit: any = [];
  existingfieldList: any = []; existingReqfieldList: any = [];
  focusinto: boolean = false;
  focusincc: boolean = false;
  isRichTextBoxReq=true;

 public _metaFieldsListSelect: any; public eventtype: number;
  _formData: any
  selectedrequest: any = 0; selectedform: any = 0;
  formConfigListSelect: any[] = [];
  //formgroup
  mailconfigForm: FormGroup;
  mailConfigs: MailConfig[];
  mailConfig: MailConfig;
  //mail template array
  mailTemps: MailTemplate[];
  submitted = false;
  key: string = 'mailconfigname'; //set default
  reverse: boolean = false;

  constructor(private MailFields: MailFieldsService,
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private dialogService: DialogService, private mailgroupService: MailgroupService, private userService: UserService,
    private route: ActivatedRoute, private router: Router,
    private mailTemplateSer: MailTemplateService, private mailConfigSer: MailconfigService,
    private databaseservice: DatabaseService, private formConfig:FormconfigService,
    private localService: LocalService
    ) {
   // this.route.params.subscribe(params => this.queryStrDb = params['db']);
    if (this.router.getCurrentNavigation().extras.state != undefined) {
      localStorage.setItem('Mail Config_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('Mail Config_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
      this.queryStrDb = this.router.getCurrentNavigation().extras.state.db;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('Mail Config_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('Mail Config_action');
    }
  }



  ngAfterViewInit() {
    this.mailconfigForm.controls['eventid'].setValue(0);
  }

  ngOnInit() {
    this.checkIsMenuMapped();
    this.mailconfigForm = this.formBuilder.group(
      {
        mailconfigname: ['', Validators.required],
        mailgroups: [''],
        subject: ['', Validators.required],
        tomailid: [''], ccmailid: [''],
        externalto: [''], externalcc: [''],
        eventid: [0], formconfigid: [0], requesttypeid: [0],
        scheduletype: [], scheduledays: [''], scheduleweeks: [0], schedulespecifictime: [], scheduleinterval: [],
        mondaycheck: [false], tuesdaycheck: [false],
        wednesdaycheck: [false],
        thursdaycheck: [false], fridaycheck: [false],
        saturdaycheck: [false],
        sundaycheck: [false]

      });
    this.hideDiv = true;
    this.searchText = '';
    this.action = 'add';
    this.scheduledtabshow = false;
    this.formTocuhed = false;
    this.LoadMailTemplateList();
    this.Loadmailgrouplist();
    this.Loadusermaillist();
    this.LoadMailConfigList();
    this.Loadmailfieldsvaluelist();
    this.getAllDatabaseList();
    this.getAllEventsList();
    this.getFormConfigData();
    this.getRequestTypeData();
    this._selectedMailTemplate = [];
    this._selectedToIds = [];
    this._selectedCcIds = [];
    this._selectedItems = [];
    this._mailConfigListTmp = [];
    this._mailConfigList = [];
    this.currentMailConfig = '';
    this._mailConfigid = '';
    this._mailTemplateId = 0;
    this.mailconfigForm.controls['eventid'].setValue(0);
    this.databases = [];
    //by default assigning value from menu rights button
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    if (this.queryStrDb == undefined) {
      this.selectedDb = true;
      this.mailconfigForm.value.dbid = 0;
    }
    else {
      this.mailconfigForm.value.dbid = this.queryStrDb;
      this.selectedDb = false;
    }
    //methods for menu rights
   this.getActionRightsList();
   // $('body').addClass('nav-sm').removeClass('nav-md');
  }

  getAllEventsList() {
    this.mailConfigSer.GetActiveEvents().subscribe(res => {
      this.events = res;
    }, error => { this.toastr.error('Error while getting Events Data'); });

  }

  checkIsMenuMapped()
  {
    const arrays = this.localService.getJsonValue("menulist");
    const notauthorized = this.localService.getJsonValue("notauthorizedmailconfig");
    let data = arrays.find(ob => ob['name'] === 'Mail configuration');
    if((data == undefined || data =='') && (notauthorized!=="true"))
    {
      this.localService.setJsonValue("notauthorizedmailconfig","true");
      this.isRichTextBoxReq=false;
      this.toastr.error('You are not authorized to access this page.');
      this.router.navigate(["home"]);
    }
    if(notauthorized=="true"){
      this.isRichTextBoxReq=false;
      this.localService.setJsonValue("notauthorizedmailconfig",null);
      this.router.navigate(["home"]);      
    }
  }

  //assigning value from menu rights button
  getActionRightsList() {
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
  }

  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  get formdata() { return this.mailconfigForm.controls; }

  //load the meta fields value details in the list from services
  Loadmailfieldsvaluelist() {
    this.MailFields.Get().subscribe(res => {
      //console.log(res);
      this._metaFieldsList = res;
      if(this.isRichTextBoxReq!=false){
      this.LoadRichtextBox();
      }
    }, error => { this.toastr.error('Error while getting the mail fields data') });
  }

  //load the mail group name in the dropdown
  Loadmailgrouplist() {
    this.mailgroupService.getmailgroups().subscribe(res => {
      if (res != undefined) {
        //console.log(res);
        var allData = res;
        allData.forEach(data => {
          if (data.active != 0) {
            this._mailGroupListtmp.push({ mailgroupid: data.mailgroupid, mailgroup: data.mailgroup });
          }
        });
        this._dropdownSettings = {
          singleSelection: false,
          idField: 'mailgroupid',
          textField: 'mailgroup',
          selectAllText: 'Select All',
          unSelectAllText: 'UnSelect All',
          itemsShowLimit: 7,
          allowSearchFilter: true
        };
        this._mailGroupList = JSON.parse(JSON.stringify(this._mailGroupListtmp));
      }
    }, error => { this.toastr.error('Error in getting group mail list'); }

    )


  };

  //load richtextbox control
  LoadRichtextBox() {

    this.richtext = new Richtext("richtext_container", {
      mode: "classic", toolbarBlocks: ["default"]
    });
    this.richtext.toolbar.data.remove("link");

    this._metaFieldsListSelect = this._metaFieldsList.filter(item => item.type == 1);
    for (var i = 0; i < this._metaFieldsListSelect.length; i++) {
      var _value = this._metaFieldsListSelect[i]['mailfields'];
      var _id = this._metaFieldsListSelect[i]['mailfieldsvalues'];
      this.richtext.toolbar.data.add(
        {
          type: "button",
          value: _value,
          id: _id
        }, i + 24);
    }


    var EditorAPI = this.richtext.getEditorAPI();
    this.richtext.toolbar.events.on("click", function (id, event) {
      //console.log(EditorAPI.getModel());
      if (id.startsWith('$$') && id.startsWith('$$file')) {
        // EditorAPI.add(id);
        EditorAPI.add(' ' + id + ' | FileSize: ' + id + 'size ');
      }
      else {
        EditorAPI.add(' ' + id + ' ');
      }
      event.preventDefault();
    });
    this.richtext.toolbar.events.on('selectionRefresh', function (event) {
      event.preventDefault();
    });

  }

  //to get the individual user mail list 
  Loadusermaillist() {
     let a= new encryptdecrypt(); 
    this.userService.Get().subscribe(
      res => {
        res.forEach((data: any) => {
        data.firstname = a.decryptUsingAES256(data.firstname);
        data.lastname = a.decryptUsingAES256(data.lastname);
        data.emailid = a.decryptUsingAES256(data.emailid);
      });
        var allData = res;
        allData.forEach(data => {
          if (data.active != 0) {
            this._userMailList.push({ userid: data.userid, emailid: data.emailid });
          }
        });
        this._toMailDropdownSettings = {
          singleSelection: false,
          idField: 'userid',
          textField: 'emailid',
          selectAllText: 'Select All',
          unSelectAllText: 'UnSelect All',
          itemsShowLimit: 7,
          allowSearchFilter: true,
          enableCheckAll: true
        };
        this._toMailList = JSON.parse(JSON.stringify(this._userMailList));
        this._ccMailList = JSON.parse(JSON.stringify(this._userMailList));
      }, error => { this.toastr.error('Error in getting user mail list'); }
    )
  }

  //Load mail config list
  LoadMailConfigList() {
    this._mailConfigList = [];
    this._mailConfigListactive = [];
    this.mailConfigSer.Get().subscribe(
      (res) => {
        if (res != undefined) {
          this._mailConfigListTmp = [];
          this._mailConfigList = [];
          this._mailConfigListTmp = res;
          var allData = res;
          allData.forEach(data => {
            this._mailConfigList.push({ mailconfigid: data.mailconfigid, mailconfigname: data.mailconfigname, active: data.active })
          });

          if (this.showallstatus == true) {
            this._mailConfigList.forEach(data => {
              if (data.active == 1) {
                this._mailConfigListactive.push(data);
              }
            });
            this._mailConfigList = [];
            this._mailConfigList = this._mailConfigListactive;
          }

        }
      });
  }

  getactiveinactive(showallp) {
    this._mailConfigListactive = [];
    this.showall = showallp;
    this.showallstatus = showallp;
    if (this.showall == true) {
      this.showall = false;
      this._mailConfigList.forEach(data => {
        if (data.active == 1) {
          this._mailConfigListactive.push(data);
        }
      });
      this._mailConfigList = [];
      this._mailConfigList = this._mailConfigListactive;
    }
    else {
      this.showall = true;
      this._mailConfigList = [];
      this.LoadMailConfigList();
    }
  }

  clearForm() {
    this.submitted = false;
    this.action = 'add';
    this._selectedToIds = [];
    this._selectedCcIds = [];
    this._selectedItems = [];
    this._selectedMailTemplate = [];
    this.scheduledtabshow = false;
    this.mailconfigForm.reset();
    this.scheduletypeedit = '';
    this.richtext.setValue('');
    this.currentMailConfig = '';
    this.scheduledtabshow = false;
    this._mailConfigid = '';
    this._mailTemplateId = 0;
    this.mailconfigForm.controls['tomailid'].setValue(this._selectedToIds);
    this.mailconfigForm.controls['ccmailid'].setValue(this._selectedCcIds);
    this.mailconfigForm.controls['externalto'].setValue('');
    this.mailconfigForm.controls['externalto'].setValue('');
    this.mailconfigForm.controls['mailgroups'].setValue(this._selectedItems);
    this.mailconfigForm.controls['eventid'].setValue(0);
    this.formconfigddl = false; this.requesttypeddl = false;
    this.formTocuhed = false;
    if (this.add == true)
      this.submitShow = true;
    else
      this.submitShow = false;
    this.selectedDb = true;
    this.queryStrDb = 0;
     this.mailconfigForm.value.dbid = 0;
    this.hideDiv = true;

    this.clearingFieldValues();
  }

  //load existing mail template list
  LoadMailTemplateList() {
    this.mailTemplateSer.Get().subscribe(
      (res) => {
        if (res != undefined) {
          this.mailTemps = res;
          var allData = res;
          allData.forEach(data => {
            if (data.active != 0) {
              this._mailTempList.push({ mailtemplateid: data.mailtemplateid, templatename: data.templatename })
            }
          });
        /*  this._toTemplateDropdownSettings = {
            singleSelection: true,
            idField: 'mailtemplateid',
            textField: 'templatename',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 7,
            allowSearchFilter: true,
            enableCheckAll: false,
            closeDropDownOnSelection: true
          };
          this._templateList = JSON.parse(JSON.stringify(this._mailTempList));*/
        }
      }, error => { this.toastr.error('Error in getting mail template data'); });
  }

  //on selecting the existing email template
  onMailTemplateSelect(eve) {
    var selectedData = eve;
    //var _selectedID = eve.mailtemplateid;
    //this._mailTemplateId = eve.mailtemplateid;
    var _selectedID = eve.target.value;
    this._mailTemplateId = eve.target.value;
  //  this.mailconfigForm.value.mailtemplateid = this._mailTemplateId;
    this.hideDiv = false;
    if (this._mailTemplateId != 0) {
      if (this.mailTemps.length != 0) {
        var s = this.mailTemps.filter(e => e.mailtemplateid == _selectedID);
        if (s != undefined) {
          this.richtext.setValue(s[0].mailcontent);
          this.mailconfigForm.controls['subject'].setValue(s[0].subject);
          if (JSON.parse(s[0].groupmapped) != null) {
            //console.log(JSON.parse(s[0].groupmapped).mailgroups);
            this._selectedItems = this.validateMailIds((JSON.parse(s[0].groupmapped)).mailgroups, this._mailGroupListtmp, 'mailgroup');
            //this._selectedItems = (JSON.parse(s[0].groupmapped)).mailgroups;
          }
          else
            this._selectedItems = [];
          if (JSON.parse(s[0].mailto) != null) {
            this._selectedToIds = this.validateMailIds((JSON.parse(s[0].mailto)).mailto, this._userMailList, 'user');
            // this._selectedToIds = (JSON.parse(s[0].mailto)).mailto;
          }
          else
            this._selectedToIds = [];
          if (JSON.parse(s[0].mailcc) != null) {
            this._selectedCcIds = this.validateMailIds((JSON.parse(s[0].mailcc)).mailcc, this._userMailList, 'user');
            //this._selectedCcIds = (JSON.parse(s[0].mailcc)).mailcc;
          }
          else
            this._selectedCcIds = [];
        }
      }
    }
    else
      this.clearForm();
  }

  //form valid mail structure suit for  multi select list
  formMultiSelectStrucuture(mappedList, mailList, type) {
    var tempList = [];
    if (type == 'mailgroup') {
      if ((mappedList != null) && (mappedList.length != 0)) {
        mailList.forEach((d) => {
          mappedList.forEach((data, ind) => {
            if (data.mailgroupid == d.mailgroupid) {
              tempList.push({
                mailgroupid: d.mailgroupid, mailgroup: d.mailgroup
              });
            }
          });
        });
      }
    }
    if (type == 'user') {
      if ((mappedList != null) && (mappedList.length != 0)) {
        mailList.forEach((d) => {
          mappedList.forEach((data, ind) => {
            if (data.userid == d.userid) {
              tempList.push({
                userid: d.userid, emailid: d.emailid
              });
            }
          });
        });
      }
    }

    mappedList = [];
    mappedList = tempList;
    return tempList;
  }

  //validate the mail id from mail template
  validateMailIds(mailTemp, activeList,type) {
    var tempList = [];
    if (type == 'mailgroup') {
      if ((mailTemp != null) && (mailTemp.length != 0)) {
        activeList.forEach((d) => {
          mailTemp.forEach((data, ind) => {
            if (data.mailgroupid == d.mailgroupid) {
              tempList.push({
                mailgroupid: d.mailgroupid, mailgroup: d.mailgroup
              });
            }
          });
        });

      }
    }
    if (type == 'user') {
      if ((mailTemp != null) && (mailTemp.length != 0)) {
        activeList.forEach((d) => {
          mailTemp.forEach((data, ind) => {
            if (data.userid == d.userid) {
              tempList.push({
                userid: d.userid, emailid: d.emailid
              });
            }
          });
        });
      }
    }
    mailTemp = [];
    mailTemp = tempList;
    return tempList;
  }

  //on deselecting the mail template dropdown
  onMailTemplateDeSelect(eve) {
    this.clearForm();
  }
  //add or update the mail configuration details in the database
  saveMailConfig(operation) {
    var _groupText = {}; var _mailToIds = {}; var _mailCcIds = {};
    this.submitted = true;
    //this.userid = +localStorage.getItem('userid');
    this.userid = +this.localService.getJsonValue('userid')
    var mailContentTxt = this.richtext.getValue("html");
    var validmailContentTxt = this.richtext.getValue("markdown");   
    this.mailconfigForm.value.dbid = this.queryStrDb;

    if ((this.mailconfigForm.value.dbid == 0) || (this.mailconfigForm.value.dbid == undefined)) {
      this.toastr.error('Please select a database');
      return;
    }
    if ((this._mailTemplateId == 0) || (this._mailTemplateId == undefined)) {
      this.toastr.error('Please select a mail template');
      return;
    }  
     
    if (this.mailconfigForm.valid) {
      if (this.mailconfigForm.value.mailconfigname.trim() == null || this.mailconfigForm.value.mailconfigname.trim() == '') {
        this.toastr.error('Mail configuration name is required');
        return;
      }
      if (((this._selectedItems == null) || (this._selectedItems.length == 0)) && ((this._selectedToIds.length == null) || (this._selectedToIds.length == 0))
        && ((this._selectedCcIds.length == null) || (this._selectedCcIds.length == 0))) {
        this.toastr.error('Please select atleast one email address');
        return;
      }
      if (this.mailconfigForm.value.subject.trim() == null || this.mailconfigForm.value.subject.trim() == '') {
        this.toastr.error('Subject should not be empty');
        return;
      }

      if ((mailContentTxt.trim() == undefined) || (mailContentTxt.trim() == '') || (mailContentTxt.trim() == '<p></p>') || (validmailContentTxt.trim() == '')) {
        this.toastr.error('Mail content is required');
        return;
      } 
      var scheduledaysvalues = []


      var a = $('div#scheduletype input[name=scheduletype]:checked').val();
      if (a === 'instant') {
        this.mailconfigForm.value.scheduletype = 'instant';
        this.mailconfigForm.value.schedulespecifictime = 0;
        this.mailconfigForm.value.scheduleinterval = 0;
      }
      else if ((a === 'scheduled')) {
        this.mailconfigForm.value.scheduletype = 'scheduled';
      }

      if (this.mailconfigForm.value.scheduletype == 'scheduled') {
        $.each($('div#Weekchbdiv input[type=checkbox]'), function (a, b) {
          var obj = {};
          obj['name'] = $(this).attr("value")
          obj['value'] = $(this).prop("checked") == true ? 1 : 0

          scheduledaysvalues.push(obj)
        })
        this.mailconfigForm.value.scheduledays = JSON.stringify(scheduledaysvalues);

        //if (this.mailconfigForm.value.schedulespecifictime) {
        //  this.mailconfigForm.value.schedulespecifictime = this.schedulespecifictime.getHours() + ":" + this.schedulespecifictime.getMinutes();
        //  this.mailconfigForm.value.scheduleinterval = 0;
        //}

        //if (this.mailconfigForm.value.scheduleinterval) {
        //  this.mailconfigForm.value.scheduleinterval = this.scheduleinterval.getHours();
        //}

        var b = $('div#schedulespecifictime input[name=specifictimeinterval]:checked').val();
        //if (b == "interval") {
        //  this.mailconfigForm.value.scheduleinterval = this.scheduleinterval.getHours();
        //  this.mailconfigForm.value.schedulespecifictime = 0
        //}
        //if (b == 'specifictime') {
        //  this.mailconfigForm.value.schedulespecifictime = this.schedulespecifictime.getHours() + ":" + this.schedulespecifictime.getMinutes();
        //  this.mailconfigForm.value.scheduleinterval = 0;
        //}
        if (!b) {
          this.toastr.warning('Please select specific time or interval to proceedd');
          return;
        }
        if (b == "interval") {
          if (!this.scheduleinterval || this.scheduleinterval.getHours() == 0) {
            this.toastr.warning('Please specify the interval hours to proceed');
            return;
          }
          this.mailconfigForm.value.scheduleinterval = this.scheduleinterval.getHours();
          this.mailconfigForm.value.schedulespecifictime = 0
        }
        if (b == 'specifictime') {
          if (this.schedulespecifictime && this.schedulespecifictime.toString() != 'Invalid Date') {
            var spectime = this.schedulespecifictime.getHours() + ":" + this.schedulespecifictime.getMinutes();
            if (spectime != '0:0') {
              this.mailconfigForm.value.schedulespecifictime = spectime;
              this.mailconfigForm.value.scheduleinterval = 0;
            }
            else {
              this.toastr.warning('Please specify the time period to proceed');
              return;
            }
          }
          else {
            this.toastr.warning('Please specify the time period to proceed');
            return;
          }
        }
      }
      else {
        this.mailconfigForm.value.scheduledays = JSON.stringify(scheduledaysvalues);
        this.mailconfigForm.value.scheduleweeks = 0;
        this.mailconfigForm.value.scheduleinterval = 0;

      }
      var externalToList = [], validmailid: boolean = true; var externalCcList = []
      var regxpat = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
      if (this.mailconfigForm.value.externalto) {

        if (this.mailconfigForm.value.externalto.trim() != null && this.mailconfigForm.value.externalto.trim() !== '') {

          //var externalToList = [], validmailid: boolean = true


          let a = this.mailconfigForm.value.externalto.split(';')
          a.forEach(data => {


            if (!regxpat.test(data)) {
              this.toastr.warning('Please enter valid External TO Mail id instead of ' + data)
              validmailid = false
              //return;
            }
            else {
              externalToList.push(data)
              validmailid = true
            }

          })
          if (!validmailid) {
            //this.toastr.warning('please enter valid Mail id ')
            return
          }

        }

      }
      if (this.mailconfigForm.value.externalcc) {

        if (this.mailconfigForm.value.externalcc.trim() != null && this.mailconfigForm.value.externalcc.trim() !== '') {

          let b = this.mailconfigForm.value.externalcc.split(';')
          b.forEach(data => {
            if (!regxpat.test(data)) {
              this.toastr.warning('Please enter valid  External CC Mail id instead of ' + data)
              validmailid = false
              // throw ('');
              //return;
            }
            else {
              externalCcList.push(data);
              validmailid = true;
            }

          })
          if (!validmailid) {
            //this.toastr.warning('please enter valid Mail id ')
            return
          }

        }

      }

      this.mailconfigForm.value.externalto = JSON.stringify(externalToList);
      this.mailconfigForm.value.externalcc = JSON.stringify(externalCcList);

      _groupText['mailgroups'] = this.mailSaveStructure(this._selectedItems, 'mailgroup');//this._selectedItems
      _mailToIds['mailto'] = this.mailSaveStructure(this._selectedToIds, 'user');//this._selectedToIds;
      _mailCcIds['mailcc'] = this.mailSaveStructure(this._selectedCcIds, 'user');//this._selectedCcIds;

      this._groupMapped = []; this._toMailIdMapped = []; this._ccMailIdMapped = [];
      this.mailconfigForm.value.groupmapped = JSON.stringify(_groupText);
      this.mailconfigForm.value.mailto = JSON.stringify(_mailToIds);
      this.mailconfigForm.value.mailcc = JSON.stringify(_mailCcIds);
      this.mailconfigForm.value.mailcontent = mailContentTxt;     
      this.mailconfigForm.value.mailtemplateid = this._mailTemplateId;
      if ((mailContentTxt.trim() != undefined) || (mailContentTxt.trim() != '') || (mailContentTxt.trim() == '<p></p>')) {

        if (this.mailconfigForm.value.eventid && this.mailconfigForm.value.eventid != 0) {
          this.mailconfigForm.value.eventid = this.selectedevent.eventid;
          if (this.selectedevent.eventtype == 1)
            this.mailconfigForm.value.requesttypeid = 0
          if (this.selectedevent.eventtype == 2)
            this.mailconfigForm.value.formconfigid = 0
        }

      //  this.mailconfigForm.value.eventid = this.selectedevent.eventid;
        //to add new mail config information
        if (operation == 'add') {
          this.mailconfigForm.value.active = 1;
          this.mailconfigForm.value.createdby = this.userid;
          this.mailConfigSer.Post(this.mailconfigForm.value).subscribe(
            (res) => {
              if (res.body != 0) {
                this.toastr.success('Data added successfully');
               
                this.LoadMailConfigList();
                this.clearForm();
              }
              else {
                this.toastr.warning('Mail Configuration exists already');
                this.mailconfigForm.value.externalto = '';
                this.mailconfigForm.value.externalcc = '';
              }
            }, error => {
              this.toastr.error(error);
              //console.log(error);
            });
        }//add end
        if (operation == 'update') {
          this.mailconfigForm.value.modifiedby = this.userid;
          this.mailconfigForm.value.mailconfigid = this._mailConfigid;
          this.mailConfigSer.Put(this.mailconfigForm.value).subscribe(
            (res) => {
              if (res.body != 0) {
                this.toastr.success('Data updated successfully');
                this.LoadMailConfigList();
                this.clearForm();
              }
              else {
                this.toastr.error('Mail Configuration exists already');
                this.mailconfigForm.value.externalto = '';
                this.mailconfigForm.value.externalcc = '';
              }
            }, error => {
              this.toastr.error(error);
              //console.log(error);
            });
        }


      }
      else {
        this.toastr.error('Mail content should not be empty');
      }
    }
  }

  onMailGroupItemSelect(item: any) {
    this.formTocuhed = true;
  }

  onMailGroupItemDeSelect(item: any) {
    this.formTocuhed = true;
  }

  onItemSelect(item: any) {
    this.formTocuhed = true;
  }

  onItemDeSelect(item: any) {
    this.formTocuhed = true;
  }

  touched() {
    this.formTocuhed = true;
  }

  onCCmailidSelect(item: any) {
    this.formTocuhed = true;
  }

  //forming the json structure before saving
  mailSaveStructure(list, type) {
    var temp = [];
    if (type == 'mailgroup') {
      if (list.length > 0) {
        list.forEach(item => {
          temp.push({ mailgroupid: item.mailgroupid })
        })
      }
    }
    if (type == 'user') {
      if (list.length > 0) {
        list.forEach(item => {
          temp.push({ userid: item.userid })
        })
      }
    }
    return temp;
  }

  //click event for edit icon in the grid
  editMailConfig(mailconfigid, mailconfigname, action) {
    this.scheduledtabshow = false;
    this.hideDiv = false;
    this.submitShow = true;    
    if ((this.currentMailConfig != '') && ((this.formTocuhed == true) || (this.mailconfigForm.touched == true))) {
      this.confirmation(mailconfigid, mailconfigname, action);
    }
    else {
      this.mailconfigForm.value.mailconfigid = mailconfigid;
      this.currentMailConfig = mailconfigname;
      this.formTocuhed = false;
      this.mailconfigForm.value.mailconfigname = null;
      if (this._mailConfigListTmp.length != 0) {
        var s = this._mailConfigListTmp.filter(e => e.mailconfigid == mailconfigid);        
        if (s != undefined) {
          this.queryStrDb = s[0].dbid;
          //this.mailconfigForm.controls['eventid'].setValue(s[0].eventid);

          if (s[0].eventid && s[0].eventid != 0)
            this.selectedevent = this.events.find(e => e.eventid == s[0].eventid);
          else
            this.mailconfigForm.controls['eventid'].setValue(0);
         // this.selectedevent = this.events.find(e => e.eventid == s[0].eventid);
          //this.selectevent = this.selectedevent;


          if (s[0].formconfigid != 0 && s[0].formconfigid) {
            this.formconfigddl = true;
            this.requesttypeddl = false
            this.labeltext = 'Form Config';
            //this.formConfigList = this.getFormConfigData().filter(obj => obj.active === 1 && obj.dbid === +this.queryStrDb)

            this.tempFormConfigList = this.formConfigList.filter(obj => obj.active === 1 && obj.dbid === +this.queryStrDb)
            this.mailconfigForm.controls['formconfigid'].setValue(s[0].formconfigid);
            //this.changeeventtype(this.selectedevent);

            this.mailconfigForm.controls['requesttypeid'].setValue(0);
            this.changeformconfig();
          }
          if (s[0].requesttypeid != 0 && s[0].requesttypeid) {
            //this.changeeventtype(this.selectedevent);
            this.requesttypeddl = true;
            this.formconfigddl = false;
            this.labeltext = 'Request Type';
            
            this.mailconfigForm.controls['requesttypeid'].setValue(s[0].requesttypeid);
            this.mailconfigForm.controls['formconfigid'].setValue(0);
            this.changerequesttype();

          }

          this.richtext.setValue(s[0].mailcontent);
          this.mailconfigForm.controls['mailconfigname'].setValue(s[0].mailconfigname);

          this.scheduletypeedit = s[0].scheduletype;
         


          if (s[0].scheduletype === 'scheduled') {


            this.scheduledtabshow = true;

            if (s[0].schedulespecifictime) {

              this.showhourpicker = false;
              this.showtimepicker = true;
              var str = s[0].schedulespecifictime
              var splitted = str.split(":"); 
              const time = new Date();
              time.setHours(splitted[0]);
              time.setMinutes(splitted[1]);
              this.schedulespecifictime = time;
             
            }
            if (s[0].scheduleinterval) {

              this.showhourpicker = true;
              this.showtimepicker = false;
              
              const time = new Date();
              time.setHours(s[0].scheduleinterval);
              time.setMinutes(0);              
              this.scheduleinterval =time
            }
            this.mailconfigForm.controls['scheduleweeks'].setValue(s[0].scheduleweeks);


            this.scheduledaysedit = JSON.parse(s[0].scheduledays);

                    
            for (var days of this.scheduledaysedit) {
              var name;
              name = days.name + 'check';
              if (days.value == 1) {
                //$('#' + name).prop('checked', true);
                this.mailconfigForm.controls[name].setValue(true);

              }
              else
              //  $('#' + name).prop('checked', false);
                this.mailconfigForm.controls[name].setValue(false);

            }
          }
          var externalTolist = [];
          if (s[0].externalto != undefined && s[0].externalto != null && s[0].externalto.length != 0)
            externalTolist = JSON.parse(s[0].externalto);
          else
            externalTolist = [];

          var externalCclist = [];
          if (s[0].externalcc != undefined && s[0].externalcc != null && s[0].externalcc.length != 0)
            externalCclist = JSON.parse(s[0].externalcc);
          else
            externalCclist = [];

         
          this.mailconfigForm.controls['externalto'].setValue(this.getemailstring(externalTolist));
          this.mailconfigForm.controls['externalcc'].setValue(this.getemailstring(externalCclist));

          this.mailconfigForm.controls['subject'].setValue(s[0].subject);
          if (JSON.parse(s[0].groupmapped) != null) {           
            this._selectedItems = this.formMultiSelectStrucuture((JSON.parse(s[0].groupmapped)).mailgroups, this._mailGroupListtmp, 'mailgroup');
            //(JSON.parse(s[0].groupmapped)).mailgroups;
          }
          else
            this._selectedItems = [];
          if (JSON.parse(s[0].mailto) != null)
            this._selectedToIds = this.formMultiSelectStrucuture((JSON.parse(s[0].mailto)).mailto, this._userMailList, 'user');
              //(JSON.parse(s[0].mailto)).mailto;
          else
            this._selectedToIds = [];
          if (JSON.parse(s[0].mailcc) != null)
            this._selectedCcIds = this.formMultiSelectStrucuture((JSON.parse(s[0].mailcc)).mailcc, this._userMailList, 'user')
              // (JSON.parse(s[0].mailcc)).mailcc;
          else
            this._selectedCcIds = [];
          this.action = action;
          this._mailConfigid = mailconfigid;
         // this.queryStrDb = s[0].dbid;
          //console.log(this.queryStrDb);
          if (s[0].mailtemplateid != undefined) {
          //  var mapped = this._mailTempList.filter(e => e.mailtemplateid == s[0].mailtemplateid);
           // this._selectedMailTemplate = JSON.parse(JSON.stringify(mapped));
            this._mailTemplateId = s[0].mailtemplateid;
          }           
        }
      }
    }
   
  }

  confirmation(mailconfigid, mailconfigname, action) {
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Confirmation',
        message: 'Would you like to save changes? ' + this.currentMailConfig,
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.saveMailConfig(action);
        }
        else {
          this.mailconfigForm.markAsUntouched();
          this.formTocuhed = false;
          this.currentMailConfig = '';
          this.editMailConfig(mailconfigid, mailconfigname, action);
        }
      });

  }

  //function to activate or deactivate the mail template
  statusChange(id, option) {
    //this.userid = +localStorage.getItem('userid');
    this.userid = +this.localService.getJsonValue('userid')
    if (option == 'activate') {
      this.confmsg = "activate";
      this.mailconfigForm.value.active = 1;
      this.msg = "Record activated successfully";
    }
    else {
      this.confmsg = "deactivate";
      this.mailconfigForm.value.active = 0;
      this.msg = "Record deactivated successfully";
    }
    this.mailconfigForm.value.mailconfigid = id;
    this.mailconfigForm.value.modifiedby = this.userid;
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + this.confmsg + ' this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true

      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.mailConfigSer.Delete(this.mailconfigForm.value).subscribe(
            (res) => {
              if (res.body != 0) {
                this.toastr.success(this.msg);
                this.LoadMailConfigList();
              }
            }, error => {
              //console.log(error);
              this.toastr.error(error);
            });
        }
      });
  }

  //get all active database list
  getAllDatabaseList() {
    this.databaseservice.getActive().subscribe(res => {      
      this.databases = res;
    }, error => { this.toastr.error('Error while getting data'); });

  }

  changedatabase(eve) {
    this.mailconfigForm.value.dbid = eve.target.value;
    this.queryStrDb = eve.target.value;
    if (eve.target.value!=0)
      this.selectedDb = false;
    else
      this.selectedDb = true;
  }

  changeeventtype(event?: any) {
    //console.log(this.selectedevent);
    this._formData = [];
    this._metaFieldsListSelect = [];
    if (this.existingReqfieldList.length != 0) {
      this.existingReqfieldList.forEach(i => {
        this.richtext.toolbar.data.remove(i.id);
      });
    }
    if (this.existingfieldList.length != 0) {
      this.existingfieldList.forEach(i => {
        this.richtext.toolbar.data.remove(i.id);
      })
    }
    this.removeeditortoolbarbutton();
    this.existingfieldList = [];
    this.existingReqfieldList = [];
    this.labeltext = null
    if (!this.queryStrDb) {
      this.toastr.warning('Please select database to proceed');

      this.mailconfigForm.controls['eventid'].setValue(0);
      return;
    }
    if (this.selectedevent.eventtype === 1) {

      this.labeltext = 'Form Config';
      this.formconfigddl = true;
      this.requesttypeddl = false;

      this.tempFormConfigList = this.formConfigList.filter(obj => obj.active === 1 && obj.dbid === +this.queryStrDb)
      if (this.tempFormConfigList.length === 0) {
        this.toastr.info('No Form Configurations with selected database');
        return;
      }

    }
    if (this.selectedevent.eventtype === 2) {
      this.labeltext = 'Request Type';
      this.requesttypeddl = true;
      this.formconfigddl = false;

    }
    if (this.selectedevent.eventtype === 3) {
      this.labeltext = '';
      this.requesttypeddl = false;
      this.formconfigddl = false;
      this.removeeditortoolbarbutton();
      this._metaFieldsListSelect = this._metaFieldsList.filter(item => item.type == 1 || item.type == 3);
      this.addeditortoolbarbutton();
    }
  }

  getFormConfigData() {

    this.formConfig.getFormConfig().subscribe(
      res => {
        this.formConfigList = res



      }, err => {
        this.toastr.error('Not able to get FormConfigData');
      })
    //return this.formConfigList;
  }

  getRequestTypeData() {

    this.mailConfigSer.GetRequestType().subscribe(
      res => {
        this.requestTypes = res
        if (this.requestTypes.length > 0) {
          //this.requesttypeddl = true;
        }
      }, err => {
        this.toastr.error('Not able to get RequestTypedata');
      })

  }

  changeschedule(event) {
    
    if (event.currentTarget.id === 'scheduledradio') {
      this.scheduledtabshow = true;
      this.showhourpicker = false; this.showtimepicker = false;
    }
    else if (event.currentTarget.id === 'instantradio') {
      this.scheduledtabshow = false;
    }
    else if (event.currentTarget.id === 'specificTimetRadio') {
      //this.= true
      this.showhourpicker = false;
      this.showtimepicker = true;
    }
    else if (event.currentTarget.id === 'intervalRadio') {

      this.showhourpicker = true;
      this.showtimepicker = false;
    }
  }

  changeformconfig() {
    if (this.existingfieldList.length != 0) {
      this.existingfieldList.forEach(i => {
        this.richtext.toolbar.data.remove(i.id);
      })
    }

    this.removeeditortoolbarbutton();
    if (this.selectedform > 0) {
      this.formConfigListSelect = [];
      this.formConfigListSelect = this.formConfigList.filter(item => item.formconfigid == this.selectedform);
    }
    else {
      this._metaFieldsListSelect = this._metaFieldsList.filter(item => item.type == 1);
      this.addeditortoolbarbutton();
      return;
    }

    this._formData = JSON.parse(this.formConfigListSelect[0].htmldata);
    if (this._formData.length > 0) {
      this.existingfieldList = [];
      this._formData.push({ name: "Document Link", label: "Document Link", id: this._formData.length + 1, formcontrolname: "documentlink" },
        { name: "Download Link", label: "Download Link", id: this._formData.length + 1, formcontrolname: "downloadlink" });
      this._formData.forEach((item, index) => {
        if (item.name != undefined && item.formcontrolname != undefined) {
          var _value = item.label;
          var _id = '$$' + item.formcontrolname;
          if (_value && _value.trim() != "") {
            this.richtext.toolbar.data.add(
              {
                type: "button",
                value: _value,
                id: _id
              }, index + 24);
            this.existingfieldList.push({ id: _id });
          }
        }
      });
    }

  }

  changerequesttype() {
    this._formData = [];
    if (this.existingReqfieldList.length != 0) {
      this.existingReqfieldList.forEach(i => {
        this.richtext.toolbar.data.remove(i.id);
      });
    }

    this.removeeditortoolbarbutton();
    this._metaFieldsListSelect = [];
    if (this.selectedrequest > 0) {
      this._metaFieldsListSelect = this._metaFieldsList.filter(item => item.type = 2 && item.id == this.selectedrequest);
    }
    else {
      this._metaFieldsListSelect = this._metaFieldsList.filter(item => item.type == 1);
    }
    // console.log(this._metaFieldsListSelect);
   // this._metaFieldsListSelect.push({ mailfields: "Request Link", id: this._metaFieldsListSelect.length + 1, mailfieldsvalues: "$$requestlink" })
    if (this.selectedevent.eventid == 12 && this.selectedevent.eventtype == 2) {//if request event is on request complete
      this._metaFieldsListSelect.push(
        { mailfields: "Request Link", id: this._metaFieldsListSelect.length + 1, mailfieldsvalues: "$$requestlink" },
        { mailfields: "Download Link", id: this._metaFieldsListSelect.length + 1, mailfieldsvalues: "$$downloadlink" }
      )
    }
    else {
      this._metaFieldsListSelect.push({ mailfields: "Request Link", id: this._metaFieldsListSelect.length + 1, mailfieldsvalues: "$$requestlink" });
    }
    this.addeditortoolbarbutton();
  }

  removeeditortoolbarbutton() {
    this._metaFieldsListSelect = this._metaFieldsListSelect.filter(item => item.type != 1);
    for (var i = 0; i < this._metaFieldsListSelect.length; i++) {
      var _value = this._metaFieldsListSelect[i]['mailfields'];
      var _id = this._metaFieldsListSelect[i]['mailfieldsvalues'];
      this.richtext.toolbar.data.remove(_id);
    }
  }
    
  addeditortoolbarbutton() {
    if (this.existingReqfieldList.length != 0) {
      this.existingReqfieldList.forEach(i => {
        this.richtext.toolbar.data.remove(i.id);
      });
    }

    this.existingReqfieldList = [];
    for (var i = 0; i < this._metaFieldsListSelect.length; i++) {
      var _value = this._metaFieldsListSelect[i]['mailfields'];
      var _id = this._metaFieldsListSelect[i]['mailfieldsvalues'];
      this.richtext.toolbar.data.add(
        {
          type: "button",
          value: _value,
          id: _id
        }, i + 24);
      this.existingReqfieldList.push({ id: _id });
    }
  }

  clearingFieldValues() {
    if (this.existingReqfieldList.length != 0) {
      this.existingReqfieldList.forEach(i => {
        this.richtext.toolbar.data.remove(i.id);
      });
    }
    if (this.existingfieldList.length != 0) {
      this.existingfieldList.forEach(i => {
        this.richtext.toolbar.data.remove(i.id);
      })
    }

    this.removeeditortoolbarbutton();
  }

  getemailstring(externallist) {
    if (externallist) {
      var externalToliststr = '';
      externallist.forEach((d) => {
        if (externalToliststr == '')
          externalToliststr = d;
        else
          externalToliststr = externalToliststr + ';' + d;
      });
    }
    return externalToliststr
  }

}
